import React from 'react';
import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import { ActivityDashboard } from '../../features/activities/dashboard/ActivityDashboard';
import { ActivityDetails } from '../../features/activities/details/ActivityDetails';
import { ActivityForm } from '../../features/activities/form/ActivityForm';
import { HomePage } from '../../features/home/HomePage';
import App from '../layout/App';
import TestErrors from '../../features/errors/TestError';
import { NotFound } from '../../features/errors/NotFound';
import { ServerError } from '../../features/errors/ServerError';
import { ProfilePage } from '../../features/profile/ProfilePage';
import { RequireAuth } from './RequireAuth';
import { RegisterSuccess } from '../../features/users/RegisterSuccess';
import { ConfirmEmail } from '../../features/users/ConfirmEmail';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        element: <RequireAuth />,
        children: [
          { path: 'activities', element: <ActivityDashboard /> },
          { path: 'activities/:id', element: <ActivityDetails /> },
          { path: 'createActivity', element: <ActivityForm key="create" /> },
          { path: 'manage/:id', element: <ActivityForm key="manage" /> },
          { path: 'profiles/:username', element: <ProfilePage /> },
          { path: 'errors', element: <TestErrors /> },
        ],
      },
      { path: '', element: <HomePage /> },
      { path: 'not-found', element: <NotFound /> },
      { path: 'server-error', element: <ServerError /> },
      { path: 'account/registerSuccess', element: <RegisterSuccess /> },
      { path: 'account/verifyEmail', element: <ConfirmEmail /> },
      { path: '*', element: <Navigate to="/not-found" /> },
    ],
  },
];

const router = createBrowserRouter(routes);

export { router };
